module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('box-widget', {
    attrs: {
      "icon": "bell"
    }
  }, [_c('template', {
    slot: "head"
  }, [_vm._v("Notification logs")]), _c('template', {
    slot: "content"
  }, [_c('ol', {
    staticClass: "mt-2 notifications-box-list"
  }, _vm._l((_vm.data), function(item, key) {
    return _c('li', {
      staticClass: "notifications-box-item"
    }, [(_vm.$scopedSlots["item"]) ? _c('div', [_vm._t("item", null, {
      item: item
    })], 2) : [_vm._v(_vm._s(item))]], 2)
  })), _c('gotu-nav-button', {
    attrs: {
      "theme": "default-cta",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.buttons.load-more')))])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14b9a4c2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications-box/NotificationsBox.vue
// module id = 2008
// module chunks = 1